import { US_STATES } from "../../constants/usStates";

export default function PatientInsuranceFormSections({ form, setForm }) {
  return (
    <>
      <section className="form-section">
        <h3 className="form-section-title">Commercial Health</h3>
        <div className="form-row">
          <label>Insurance Name</label>
          <input
            value={form.commercialInsuranceName || ""}
            onChange={(e) => setForm((p) => ({ ...p, commercialInsuranceName: e.target.value }))}
          />
        </div>
        <div className="form-row">
          <label>Insured Name</label>
          <input
            value={form.commercialInsuredName || ""}
            onChange={(e) => setForm((p) => ({ ...p, commercialInsuredName: e.target.value }))}
          />
        </div>
        <div className="form-row">
          <label>Member ID Number</label>
          <input
            value={form.commercialMemberId || ""}
            onChange={(e) => setForm((p) => ({ ...p, commercialMemberId: e.target.value }))}
          />
        </div>
        <div className="form-row">
          <label>Group Number</label>
          <input
            value={form.commercialGroupNumber || ""}
            onChange={(e) => setForm((p) => ({ ...p, commercialGroupNumber: e.target.value }))}
          />
        </div>
      </section>

      <section className="form-section">
        <h3 className="form-section-title">Auto</h3>
        <div className="form-row">
          <label>Carrier Name</label>
          <input
            value={form.autoCarrierName || ""}
            onChange={(e) => setForm((p) => ({ ...p, autoCarrierName: e.target.value }))}
          />
        </div>
        <div className="form-row">
          <label>Policy Number</label>
          <input
            value={form.autoPolicyNumber || ""}
            onChange={(e) => setForm((p) => ({ ...p, autoPolicyNumber: e.target.value }))}
          />
        </div>
        <div className="form-row">
          <label>Claim Number</label>
          <input
            value={form.autoClaimNumber || ""}
            onChange={(e) => setForm((p) => ({ ...p, autoClaimNumber: e.target.value }))}
          />
        </div>

        <h4 className="form-subsection-title">Coverage Information</h4>
        <div className="form-row">
          <label>Med Pay Amount</label>
          <input
            value={form.autoMedPayAmount || ""}
            onChange={(e) => setForm((p) => ({ ...p, autoMedPayAmount: e.target.value }))}
          />
        </div>
        <div className="form-row">
          <label>State Of Issuance</label>
          <select
            value={form.autoStateOfIssuance || ""}
            onChange={(e) => setForm((p) => ({ ...p, autoStateOfIssuance: e.target.value }))}
          >
            <option value="">Select a state</option>
            {US_STATES.map((state) => (
              <option key={state.code} value={state.code}>
                {state.name}
              </option>
            ))}
          </select>
        </div>
        <div className="form-row">
          <label>Total Benefit</label>
          <input
            value={form.autoTotalBenefit || ""}
            onChange={(e) => setForm((p) => ({ ...p, autoTotalBenefit: e.target.value }))}
          />
        </div>
        <div className="form-row">
          <label>UM Amount</label>
          <input
            value={form.autoUmAmount || ""}
            onChange={(e) => setForm((p) => ({ ...p, autoUmAmount: e.target.value }))}
          />
        </div>

        <div className="form-row">
          <label>Adjuster&apos;s Name</label>
          <input
            value={form.autoAdjusterName || ""}
            onChange={(e) => setForm((p) => ({ ...p, autoAdjusterName: e.target.value }))}
          />
        </div>
        <div className="form-row">
          <label>Adjuster&apos;s Phone Number</label>
          <input
            value={form.autoAdjusterPhone || ""}
            onChange={(e) => setForm((p) => ({ ...p, autoAdjusterPhone: e.target.value }))}
          />
        </div>
        <div className="form-row">
          <label>Adjuster&apos;s Email</label>
          <input
            type="email"
            value={form.autoAdjusterEmail || ""}
            onChange={(e) => setForm((p) => ({ ...p, autoAdjusterEmail: e.target.value }))}
          />
        </div>
      </section>

      <section className="form-section">
        <h3 className="form-section-title">Third Party</h3>
        <div className="row" style={{ marginBottom: 8, flexWrap: "wrap", gap: 16 }}>
          <label className="symptom-option">
            <input
              type="checkbox"
              className="symptom-checkbox"
              checked={!!form.thirdPartyPremise}
              onChange={(e) => setForm((p) => ({ ...p, thirdPartyPremise: e.target.checked }))}
            />
            <span>Premise</span>
          </label>
          <label className="symptom-option">
            <input
              type="checkbox"
              className="symptom-checkbox"
              checked={!!form.thirdPartyAuto}
              onChange={(e) => setForm((p) => ({ ...p, thirdPartyAuto: e.target.checked }))}
            />
            <span>Auto</span>
          </label>
          <label className="symptom-option">
            <input
              type="checkbox"
              className="symptom-checkbox"
              checked={!!form.thirdPartyUmbrella}
              onChange={(e) => setForm((p) => ({ ...p, thirdPartyUmbrella: e.target.checked }))}
            />
            <span>Umbrella</span>
          </label>
        </div>
        <div className="form-row">
          <label>Carrier&apos;s Name</label>
          <input
            value={form.thirdPartyCarrierName || ""}
            onChange={(e) => setForm((p) => ({ ...p, thirdPartyCarrierName: e.target.value }))}
          />
        </div>
        <div className="form-row">
          <label>Coverage</label>
          <input
            value={form.thirdPartyCoverage || ""}
            onChange={(e) => setForm((p) => ({ ...p, thirdPartyCoverage: e.target.value }))}
          />
        </div>
      </section>
    </>
  );
}
